import { FC } from "react";
import { formatNumberWithSuffix } from "../../../../common/Number";
import { ScoreTag } from "../../../../common/components/ScoreTag";
import { ListCardTag } from "../../../../common/components/ListCard";
import { IdentifiedSavings, SavingsProgress } from "../../../negotiations/v2/list/components/DealSavings";
import { SpendTally } from "../vendorSpend";
import { isCancelledDeal, OrderForm } from "../../../../types/OrderFormTypes";

/** The average deal score of a tally, as on a deal row; a dash when nothing is scored. */
export const AverageScoreCell: FC<{ tally: SpendTally }> = ({ tally }) =>
    tally.score === undefined ? (
        <>–</>
    ) : (
        <ScoreTag score={tally.score} type="percentage" showGrade />
    );

/** The total deal value of a tally, as on a deal row. */
export const TotalValueCell: FC<{ tally: SpendTally }> = ({ tally }) => (
    <ListCardTag color="grey">${formatNumberWithSuffix(tally.value)}</ListCardTag>
);

/**
 * The savings of a tally against its target: banked solid, pending hatched.
 * On a deal row, pass the deal: once cancelled it shows only what it had
 * identified, which the tally no longer counts.
 */
export const SavingsCell: FC<{ tally: SpendTally; deal?: OrderForm }> = ({ tally, deal }) =>
    deal && isCancelledDeal(deal) ? (
        <IdentifiedSavings target={deal.targetedSavings} />
    ) : (
        <SavingsProgress
            target={tally.targetedSavings}
            realized={tally.realizedSavings}
            pending={tally.pendingSavings}
        />
    );
